import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import { useMemo, useState } from "react";
import { MaterialVariantsFilter } from "src/generated/graphqlTypes";
import {
  AddEditItemModal_MvFragment,
  useAddEditItemModal_GetMaterialVariantsQuery,
} from "src/routes/libraries/plan-package/takeoffs/components/AddItems/AddEditItemModal.generated";

export type MaterialVariantSelectFieldProps = Omit<
  BoundSelectFieldProps<AddEditItemModal_MvFragment, string>,
  "options"
> & {
  //* * Default filter to be used when pulling variants */
  filter: MaterialVariantsFilter;
  initialOptions: AddEditItemModal_MvFragment[];
};

/** Material Variant select field that load options based on user's search
 * This component loads Material Variants and it's MAVs
 */
export function MaterialVariantSelectField({ filter, initialOptions, ...props }: MaterialVariantSelectFieldProps) {
  const [search, setSearch] = useState<string>();
  const { data } = useAddEditItemModal_GetMaterialVariantsQuery({
    // Bumping the limit to 200, to where users can search materials variants without any attributes, and it will be returned in one page.
    // I.e. we have ~120 interior doors that all share the same code
    variables: { filter: { ...filter, search }, page: { limit: 200 } },
    fetchPolicy: "cache-first",
  });

  const options = useMemo(
    () => [...initialOptions, ...(data?.materialVariants.entities ?? [])].uniqueByKey("id"),
    [data, initialOptions],
  );

  return <BoundSelectField {...props} options={options} onSearch={setSearch} />;
}
